import { CommandeMS, TabKind } from '../types';
import { isCandidatureEditable } from './commandeMsCandidature';
import { isTabReachable } from './commandeMsTabs';

// Decisions PURES des CTA de bascule d'onglet (NextTabButton) de la case PRESTATAIRE x MS. Aucune
// dependance React, aucune I/O : le JSX ne fait que consommer { target, label, hidden }.
//
// POURQUOI un module dedie plutot qu'un ternaire dans chaque onglet : la regle d'affichage d'un CTA
// de bascule croise deux sources que les composants ne partagent pas —
//   1. l'ATTEIGNABILITE de la destination (commandeMsTabs) : proposer une bascule vers un onglet
//      grise donnerait un bouton mort, goToTab refusant d'ouvrir la destination ;
//   2. l'existence d'une action orange CONCURRENTE sur l'onglet courant : le CTA de navigation est
//      un repli quand aucune action n'est due, jamais un rival de l'action du moment.
// Centraliser evite que chaque onglet ne reimplemente qu'une moitie de la regle.

export interface NextTabCta {
  target: TabKind;
  label: string;
  hidden: boolean;
}

// Consultation -> Offre, ET Questions/reponses -> Offre : MEME CTA (meme destination, meme libelle),
// d'ou une seule fonction pour les deux onglets.
// Seul le LIBELLE suit la fenetre de depot : tant que l'offre est deposable, c'est une invitation a
// agir ; une fois deposee (ou la fenetre fermee), c'est un simple acces en lecture. Le bouton reste
// orange dans les deux cas — c'est l'unique action de navigation de ces onglets, donc leur CTA.
export const ctaVersOffre = (commande: CommandeMS, chronoExpired = false): NextTabCta => ({
  target: 'candidature',
  label: isCandidatureEditable(commande, chronoExpired) ? 'Déposer mon offre' : "Voir l'offre",
  hidden: !isTabReachable(commande, 'candidature'),
});

// Offre -> Notifications et signatures.
// Masque tant que l'offre est editable : l'onglet porte alors sa propre action orange ("Soumettre
// l'offre"), qui est le CTA du moment. Condition aujourd'hui redondante avec l'atteignabilite
// (editable => statut < 4, or l'onglet n'ouvre qu'a >= 8) : on la nomme quand meme, car c'est la
// regle metier qui tient le masquage, pas la coincidence actuelle des deux seuils.
export const ctaVersNotifications = (commande: CommandeMS, chronoExpired = false): NextTabCta => ({
  target: 'notifications',
  label: 'Accéder au marché signé',
  hidden:
    !isTabReachable(commande, 'notifications') || isCandidatureEditable(commande, chronoExpired),
});

// Notifications et signatures -> Messagerie. L'onglet Messagerie n'ouvre qu'au marche signe des deux
// cotes (statut 11) : la meme condition grise l'onglet et masque le CTA -> une seule source de
// verite (l'atteignabilite), au lieu de redire le seuil ici.
export const ctaVersMessagerie = (commande: CommandeMS): NextTabCta => ({
  target: 'messagerie',
  label: 'Aller dans la messagerie',
  hidden: !isTabReachable(commande, 'messagerie'),
});

// Messagerie -> Evaluation. Cote presta, l'evalue est l'ACHETEUR : c'est la case soeur acheteur qui
// porte le sens inverse ("Evaluer le prestataire").
export const ctaVersEvaluation = (commande: CommandeMS): NextTabCta => ({
  target: 'evaluation',
  label: "Évaluer l'acheteur",
  hidden: !isTabReachable(commande, 'evaluation'),
});
